export default __webpack_public_path__ + "static/media/loader.9e6507df.svg";